<template>
  <div class="l-container offers page-promo-banner promo-block">
    <div class="custom-banner">
      <picture class="image">
        <source
          class="image"
          type="image/webp"
          :srcset="imgMobWebp"
          media="(max-width: 623.4px)"
        />
        <source
          class="image"
          type="image/jpeg"
          :srcset="imgMobJpg"
          media="(max-width: 623.4px)"
        />
        <source
          class="image"
          type="image/webp"
          :srcset="imgJpg"
        />
        <source
          class="image"
          type="image/jpeg"
          :srcset="imgWebp"
        />
        <img class="image" :src="imgJpg" alt="promo" />
      </picture>
    </div>
  </div>
</template>
<script lang="ts" setup>
defineProps({
  // рекомендуемый размер 1198*486
  imgMobJpg: {
    type: String,
    default: '',
  },
  imgMobWebp: {
    type: String,
    default: '',
  },
  // рекомендуемый размер 3040*916
  imgJpg: {
    type: String,
    default: '',
  },
  imgWebp: {
    type: String,
    default: '',
  },
});
</script>
<style lang="scss" scoped src="./promo-custom-image-banner.scss"></style>
